import { useQuery } from "@tanstack/react-query";
import { api, type Entitlements, type User } from "@/lib/api";

export function useMe() {
  return useQuery({ queryKey: ["me"], queryFn: () => api<{ user: User | null }>("/api/me").then((r) => r.user), staleTime: 60_000 });
}

export function useEntitlements(enabled = true) {
  return useQuery({ queryKey: ["entitlements"], queryFn: () => api<Entitlements>("/api/entitlements"), enabled, staleTime: 60_000 });
}
